import { all, AllEffect } from 'redux-saga/effects';
import UserDetailsReducer from './duck/reducer';

function* UserDetailsSaga(): Generator<AllEffect<Generator>> {
  yield all([]);
}

export { UserDetailsReducer, UserDetailsSaga };
